import React from 'react';
import { Flashbar, FlashbarProps } from '@cloudscape-design/components';
import { useNotificationStore, NotificationType } from 'src/store/notification-store';
import './Notification.scss';

/**
 * Map notification types to Cloudscape Flashbar types
 */
const mapNotificationType = (type: NotificationType): FlashbarProps.Type => {
    const typeMap: Record<NotificationType, FlashbarProps.Type> = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info',
    };
    return typeMap[type];
};

/**
 * Global notification component that displays notifications from the notification store
 * Uses Cloudscape Flashbar component for consistent styling
 */
export const Notification: React.FC = () => {
    const { notifications, removeNotification } = useNotificationStore();

    // Convert notifications to Flashbar items
    const items: FlashbarProps.MessageDefinition[] = notifications.map((notification) => ({
        type: mapNotificationType(notification.type),
        header: notification.header,
        content: notification.content,
        dismissible: notification.dismissible,
        onDismiss: () => removeNotification(notification.id),
        id: notification.id,
    }));

    return (
        <div className="notification-container">
            <Flashbar items={items} />
        </div>
    );
};